<template>
  <el-card>
    <div slot="header">
      EDI
    </div>
    <el-form
      ref="ediDataForm"
      :model="ediData"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ILN">
            <el-input
              v-model="ediData.iln"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_order_send_active"
            >
              EDI rendelés küldés engedélyezve
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_order_send_test"
            >
              Teszt üzemmód
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_order_receive_active"
            >
              EDI rendelés fogadás engedélyezve
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_desadv_send_active"
            >
              EDI szállítólevél küldés engedélyezve
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-checkbox
              v-model="ediData.edi_desadv_send_test"
            >
              Teszt üzemmód
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['partner'],
  data() {
    return {
      ediData: {
        edi_order_send_active: false,
        edi_order_send_test: false,
        edi_order_receive_active: false,
        edi_desadv_send_active: false,
        edi_desadv_send_test: false,
        iln: null
      }
    };
  },
  watch: {
    partner(newVal) {
      if (newVal) {
        this.ediData.edi_order_send_active = newVal.edi_order_send_active || false;
        this.ediData.edi_order_send_test = newVal.edi_order_send_test || false;
        this.ediData.edi_order_receive_active = newVal.edi_order_receive_active || false;
        this.ediData.edi_desadv_send_active = newVal.edi_desadv_send_active || false;
        this.ediData.edi_desadv_send_test = newVal.edi_desadv_send_test || false;
        this.ediData.iln = newVal.iln || null;
      }
    },
  },
};
</script>
